import http from '../shared/HttpCommon';
import { CommunityManagement } from '../shared/interfaces/ICommunityManagement';

const startScraping = async (
  platform: string,
  company: string,
  label: string,
  url: string,
  isBenchmark: boolean,
  communityManagement: CommunityManagement | null
): Promise<string[]> => {
  try {
    const { data } = await http.post(`/${platform.toLowerCase()}/scrape`, {
      company,
      label,
      url,
      isBenchmark,
      communityManagement,
    });
    // Job UUIDs
    return data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

const ScrapeService = {
  startScraping,
};

export default ScrapeService;
